import * as React from "react";
import { SVGProps } from "react";
export function MemberHandshakeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={31}
      height={31}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.656 21.81h1.79l4.688 2.69a6.77 6.77 0 0 0 3.347.89M22.21 22.578l1.342-.769h1.79M15.499 25.39a6.769 6.769 0 0 0 3.347-.89l1.875-1.088-3.45-5.184-2.485.619a3.211 3.211 0 0 1-.74.084c-.472 0-.938-.109-1.36-.319a1.396 1.396 0 0 1 .075-2.54l4.753-2.035a3.46 3.46 0 0 1 1.388-.28c.694-.001 1.372.204 1.95.59l1.8 1.2h2.69"
        stroke="#7522C5"
        strokeWidth={1.2}
        strokeMiterlimit={10}
      />
      <path
        d="M5.656 15.547h2.682l1.8-1.2a3.506 3.506 0 0 1 1.95-.59 3.46 3.46 0 0 1 1.387.28l2.025.872M25.344 13.756V23.6M5.656 13.756V23.6M15.502 7.494l.43.88.985.142-.712.684.168.975-.871-.46-.872.46.168-.975-.712-.684.984-.141.432-.881Z"
        stroke="#7522C5"
        strokeWidth={1.2}
        strokeMiterlimit={10}
      />
    </svg>
  );
}
